import React from 'react';

const MediaFilesMessage = ({ max, alerts = false }) => {
  return (
    <>
      <div>
        <p style={{
          padding: "3px 0px",
          fontStyle: "italic",
          fontSize: "14px",
          fontFamily: "lato",
          fontWeight: "normal",
          textAlign: "left",
          color: "#535353",
          opacity: "1",
        }}>
          { !alerts ? 
          `You can add up to ${max} files (images, videos) and unlimited online videos` 
          : 
          `You can add up to ${max} file (image)`}
        </p>
      </div>
    </>
  );
};

export default MediaFilesMessage;
